import axios from 'axios'

const endPoint = "feeds"

export function coachingTracks({ commit, rootState }) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/coachinggroup/fetch/${rootState.auth.authUser._id}`)
            .then(response => {
                commit('setCoachingTracks', response.data.data)
                // would automaically set activeCT to first item, keeping just in case
                // if (response.data.data.length > 0) commit('setActiveCT', response.data.data[0])
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getTimelines({ commit, state }, payload) {
    var parameters = {
        "per_page": 20,
        "user_ids": [],
        "coaching_track_id": payload.type != 'home' ? payload._id : '',
        "insight_group_id": "",
        "tags": [],
        "from_date": "",
        "to_date": "",
        "end_date": "",
        "order": "",
        "userId": payload.userId,
        "type": payload.type
    };

    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/timeline?page=${payload.page}`, parameters)
            .then(response => {
                commit('setTimelines', response.data.data)
                // console.log("Returned Feed Data:", response.data.data);
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function fetchTaggableUsers({ commit, state }) {
    return new Promise((resolve, reject) => {
        if (state.taggableUsers && state.taggableUsers.length > 0) {
            // console.log("Using cached taggable users");
            resolve({ data: state.taggableUsers });
            return;
        }

        axios
            .get(`${endPoint}/fetchtaggableusers`)
            .then(response => {
                // console.log("Fetched taggable users: ", response.data.data);
                commit('setTaggableUsers', response.data.data);
                resolve(response.data);
            })
            .catch(err => {
                console.error('Error fetching taggable users:', err);
                reject(err);
            });
    });
}

export function createPost({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}`, payload)
            .then(response => {
                // commit('pushCoachingTrack', response.data.data)
                commit("setLastUpdated")
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function reactPost({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feedId}/reactPost`, payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function reactComment({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feedId}/comments/${payload.commentId}/reactComment`, payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function likePost({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feedId}/Likes`, payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function reactionPost({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feedId}/Reaction`, payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function reactionCommentPost({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feedId}/Reaction/Comment/${payload.commentId}`, payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getReactions({ commit, state }, feedId) {
    return new Promise((resolve, reject) => {
        axios
            .get(`${endPoint}/${feedId}/Reaction`)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getCommentReactions({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .get(`${endPoint}/${payload.feedId}/Reaction/Comment/${payload.commentId}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function likeComment({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feedId}/comments/${payload.commentId}/likeUnlike`, payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function sharePost({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feedId}/Shares/`, payload)
            .then(response => {
                commit("setLastUpdated")
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function editPost({ commit, state }, payload) {
    let id = state.timeline.type == "Share" ? state.timeline.share_id : state.timeline.feed_id

    return new Promise((resolve, reject) => {
        axios
            .put(`${endPoint}/${id}`, payload)
            .then(response => {
                commit("setLastUpdated")
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function removePost({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/deletefeed`, payload)
            .then(response => {
                commit("setLastUpdated")
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function linkPreview({ commit, state }, payload) {
    var parameters = {
        "q": payload,
        "key": process.env.LINK_PREVIEW_KEY,
    };
    var header = { params: parameters };
    return new Promise((resolve, reject) => {
        axios
            .get(process.env.LINK_PREVIEW_API, header)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function createComment({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${endPoint}/${payload.feed_id}/comments`, payload.params)
            .then(response => {
                commit("setLastUpdated")
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function loadMoreComments({ commit, state }, payload) {

    let api = "";
    if (payload.type == 'share') {
        api = `/Shares/${payload.shareId}/sharecomments`;
    } else {
        api = `/comments`;

    }

    return new Promise((resolve, reject) => {
        axios
            .get(`${endPoint}/${payload.feedId}${api}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function addGroupNotes({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .put(`group-notes/${state.activeCT._id}`, payload)
            .then(response => {
                this.dispatch('groups/coachingTracks')
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function updateCoacheeActionItems({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post(`actionitems/${payload._id}`, payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getCoacheeActionItems({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .get(`actionitems/coachee/${payload._id}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getCoachActionItems({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .get(`actionitems/coach/${payload._id}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}


export function resetStore({ commit, store }) {
    commit('resetStore')
}
